<template>
  <div class="product-wrap">
    <hight-light text="产品中心" bg-text="Product Center" :is-bg="true" id="title"/>
    <div class="content">
      <navbar :current-type="currentType" @itemClick="itemClick"/>
      <div class="productList">
        <ProductList :projects="currentList" img-height="280px" type="product"></ProductList>
      </div>
    </div>
  </div>
</template>

<script>
  import HightLight from "@/components/common/hightLight/HightLight";
  import Navbar from "@/views/product/navbar/Navbar";
  import ProductList from "@/components/common/productList/ProductList";
  import {eduProducts,lanProducts,indProducts} from "@/assets/products";

  export default {
    name: "Product",
    components: {HightLight, Navbar, ProductList},
    data() {
      return {
        eduProducts,
        lanProducts,
        indProducts,
        currentType:'',
        currentList:null
      }
    },
    beforeRouteLeave (to, from, next) {
      console.log(to, from)
      if (to.path === '/detail') {
        sessionStorage.setItem('currentType', this.currentType)
      } else {
        sessionStorage.removeItem('currentType')
      }
      next()
    },
    beforeRouteEnter (to, from, next) {
      next (vm => {
        if (from.path === '/detail') {
          vm.currentType = sessionStorage.getItem('currentType')
          if(vm.currentType === '破碎设备') {
            vm.currentList = eduProducts
          } else if (vm.currentType === '筛分设备') {
            vm.currentList = lanProducts;
          } else {
            vm.currentList = indProducts
          }
        } else {
          vm.currentType ='破碎设备'
          vm.currentList= eduProducts
        }
      })
    },
    mounted(){ },
    methods:{
      itemClick(item) {
        switch (item) {
          case '破碎设备':
            this.currentList = eduProducts
            this.currentType='破碎设备'
            break;
          case '筛分设备':
            this.currentList = lanProducts
            this.currentType='筛分设备'
            break;
          case '输送设备':
            this.currentList = indProducts
            this.currentType='输送设备'
        }
      }
    }
  }
</script>

<style lang="less" scoped>
.product-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  .content {
    display: flex;
    .productList{
      padding-left: 20px;
    }
  }

}


</style>
